import { render, staticRenderFns } from "./PurchaseOrderSideMenu.vue?vue&type=template&id=c31fca90&scoped=true"
import script from "./PurchaseOrderSideMenu.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderSideMenu.vue?vue&type=style&index=0&id=c31fca90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31fca90",
  null
  
)

export default component.exports